// browser fs-extra hack
export default null
